module.exports = __webpack_public_path__ + "assets/star-half-218084.svg";